import { Component } from "@angular/core";

@Component({
    selector: "pl-footer",
    template: `
    <footer class="pl-footer">
        <div class="pl-footer__container">
            <p>
                ©{{currentYear}} Experian Information Solutions, Inc. Experian Marketing
                Services, all rights reserved
            </p>
            <p>
                Experian and the Experian marks used herein are service marks or
                registered trademarks of Experian Informations Solutions, Inc
            </p>
            <p>
                Other product and company names mentioned herein are the property of
                their respective owners.
            </p>
        </div>
    </footer>`,
    styles: [
        `
    .pl-footer {
        bottom: 0;
        display: inline-block;
        left: 0;
        margin-top: 8px;
        padding: 16px;
        right: 0;
        width: 100%;
      
        &__container {
          position: relative;
          text-align: center;
          padding-top: 32px;
          margin-bottom: 16px;
      
            p {
              font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
              font-size: 12px;
              line-height: 18px;
              font-weight: 400;
              color: #828588;
              margin: 0;
            }
      
        }
      
        &::before {
          position: absolute;
          left: 0;
          right: 0;
          content: "";
          height: 2px;
          background: linear-gradient(45deg, #af1685, #1d4f91);
        }
      }
    `,
    ],
    standalone: false
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
